import { graphql } from '@/gql';
import type { BlockedInstacartAccountMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const blockedInstacartAccount = async ({
  email,
  owner,
  lastDigits,
  followUpNotes,
  notes,
}: BlockedInstacartAccountMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      email,
      owner,
      lastDigits,
      followUpNotes,
      notes,
    },
    mutation: graphql(`
      mutation BlockedInstacartAccount($email: String!, $owner: String!, $lastDigits: String!, $followUpNotes: String, $notes: String) {
        blockedInstacartAccount(email: $email, owner: $owner, lastDigits: $lastDigits, followUpNotes: $followUpNotes, notes: $notes)
      }
    `),
  });

  return response.data?.blockedInstacartAccount ?? false;
};
